export const ColorPrimaryTextos = "#3F425D";
export const ColorSecundarioTextos = "#00000080";
export const ColorFondoPrimario = "#F6F8FB";

//Tablas
export const ColorHoverFila = "#d6d6d6";
export const ColorFondoHeader = "#F6F8FB";
export const ColorFondoFooter = "#d6d6d6";
export const ColorFondoFilaEven = "#9797970a";

//Botones
export const ColorBotonPrimario = "#082478";
export const ColorLetraBotonPrimario = "#FFFFFF";
export const ColorBotonSecundario = "#EDF0F4";
export const ColorLetraBotonSecundario = "#4F4F4F";

//tabs 
export const ColorIconoTabsActivas = "#17B6CA";
export const ColorBGTabsActivas = "#17B6CA33";
export const ColorIconoTabsInactivas = "#97A2A8";
export const ColorBGTabsInactivas = "#97A2A833";

//colores defecto barra navegación superior
export const defaultNavBarColor = "#262048";
export const defaultNavLineColor = "#68C0BB";
export const defaultNavTextColor = "#FFFFFF";
export const defaultNavIconColor = "#FFFFFF";
export const defaultNavIconBG = "transparent";

